class ComponentDisplayExtension {
    //IFRAME: Code to check displaying based on querystring
    static isDisplay = (props) => {
        //Get Data from QueryString
        var params = new URLSearchParams('');
        if (typeof window !== 'undefined') {
            params = new URLSearchParams(window.location.search);
        }

        var paramRenderings = params.get('renderings');
        var displayRenderings = typeof paramRenderings === "string" ? paramRenderings.toLowerCase().split(',') : null

        var paramRenderingIds = params.get('renderingids');
        var displayRenderingIds = typeof paramRenderingIds === "string" ? paramRenderingIds.toLowerCase().split(',') : null

        var paramXRendering = params.get('xrenderings');
        var excludeRendering = typeof paramXRendering === "string" ? paramXRendering.toLowerCase().split(',') : null

        var paramXRenderingIds = params.get('xrenderingids');
        var excludeRenderingIds = typeof paramXRenderingIds === "string" ? paramXRenderingIds.toLowerCase().split(',') : null
        //----------------------------

        //Calculate logic for displaying
        var displayFromName = true;
        var componentName = props.rendering.componentName.toLowerCase();
        //var hasDisplayRenderings = props.displayrenderings != null ? true : false;
        var hasDisplayRenderings = displayRenderings != null ? true : false;
        if (hasDisplayRenderings) {
            displayFromName = displayRenderings.includes(componentName);
        }

        var displayFromId = true;
        var renderingIds = '{' + props.rendering.uid.toLowerCase() + '}';
        //var hasDisplayRenderingIds = props.displayrenderingids != null ? true : false;
        var hasDisplayRenderingIds = displayRenderingIds != null ? true : false;
        if (hasDisplayRenderingIds) {
            displayFromId = displayRenderingIds.includes(renderingIds);
        }

        var excludeFromName = false;
        //var hasExcludeRenderings = props.excluderenderings != null ? true : false;
        var hasExcludeRenderings = excludeRendering != null ? true : false;
        if (hasExcludeRenderings) {
            excludeFromName = excludeRendering.includes(componentName);
        }

        var excludeFromId = false;
        //var hasExcludeRenderingIds = props.excluderenderingids != null ? true : false;
        var hasExcludeRenderingIds = excludeRenderingIds != null ? true : false;
        if (hasExcludeRenderingIds) {
            excludeFromId = excludeRenderingIds.includes(renderingIds);
        }

        return (displayFromName && displayFromId && !excludeFromName && !excludeFromId);
        //----------------------------------------------
    }
}

export default ComponentDisplayExtension;